<template>
  <v-container>
    <v-row>
      <v-col cols="12">
        <v-card>
          <v-card-title>
            Pages de sondage
            <v-spacer></v-spacer>
            <v-btn color="primary" @click="openNewInvestigation">
              Nouvelle page
            </v-btn>
          </v-card-title>

          <v-expansion-panels>
            <v-expansion-panel v-for="(investigation, index) in investigations" :key="investigation.id">
              <v-expansion-panel-header>
                <v-row align="center" no-gutters>
                  <v-col cols="3">
                    <span class="text-h6 font-weight-medium">
                      {{ investigation.title || `Sondage ${index + 1}` }}
                    </span>
                    <div v-if="investigation.titleEn" class="text-caption text--secondary">
                      {{ investigation.titleEn }}
                    </div>
                  </v-col>
                  <v-col cols="9" class="d-flex justify-space-around align-center">
                    <div style="
                        display: inline-block;
                        background-color: #89d624;
                        color: white;
                        padding: 6px 12px;
                        border-radius: 16px;
                        font-weight: 500;
                        white-space: normal;
                        max-width: 100%;
                        word-break: break-word;
                        line-height: 1.4;
                        margin: 10px;
                      ">
                      Nombre de réponse : {{ investigation.nbrResponse }}
                    </div>
                    <div style="
                        display: inline-block;
                        background-color: #ffb400;
                        color: white;
                        padding: 6px 12px;
                        border-radius: 16px;
                        font-weight: 500;
                        white-space: normal;
                        max-width: 100%;
                        word-break: break-word;
                        line-height: 1.4;
                        margin: 10px;
                      ">
                      Nombre d'ignore : {{ investigation.nbrIgnore }}
                    </div>
                    <div style="
                        display: inline-block;
                        background-color: #89d624;
                        color: white;
                        padding: 6px 12px;
                        border-radius: 16px;
                        font-weight: 500;
                        white-space: normal;
                        max-width: 100%;
                        word-break: break-word;
                        line-height: 1.4;
                        margin: 10px;
                      ">
                      <!-- <v-icon left>mdi-counter</v-icon> -->
                      Total nombre reçus :
                      {{ investigation.nbrResponse + investigation.nbrIgnore }}
                    </div>
                  </v-col>
                </v-row>
                <template v-slot:actions>
                  <v-btn icon small @click.stop="editInvestigation(investigation)" class="mr-2">
                    <v-icon small>mdi-pencil</v-icon>
                  </v-btn>
                  <v-btn icon small color="error" @click.stop="deleteInvestigation(investigation)">
                    <v-icon small>mdi-delete</v-icon>
                  </v-btn>
                  <v-btn color="primary" @click.stop="generateExcel(investigation)">
                    exporter CSV
                  </v-btn>
                </template>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-expansion-panels>
                  <v-expansion-panel v-for="question in investigation.investigationQstRespList" :key="question.id">
                    <v-expansion-panel-header>
                      {{ question.question }}
                      <template v-slot:actions>
                        <v-chip small :color="getMostVotedColor(question.investigationRespRespList)">
                          {{ getTotalVotes(question.investigationRespRespList) }}
                          votes
                        </v-chip>
                      </template>
                    </v-expansion-panel-header>
                    <v-expansion-panel-content>
                      <v-list>
                        <v-list-item v-for="response in question.investigationRespRespList" :key="response.id">
                          <v-list-item-content>
                            <v-list-item-title class="d-flex align-center">
                              <span class="flex-grow-1">{{ response.response }}</span>
                              <v-chip class="ml-2" :color="getColorByVotes(response.numberVote)" small>
                                {{ response.numberVote }} votes
                              </v-chip>
                            </v-list-item-title>
                            <v-list-item-subtitle>
                              <v-progress-linear
                                :value="getPercentage(response.numberVote, question.investigationRespRespList)"
                                height="8" :color="getColorByVotes(response.numberVote)"
                                class="mt-2"></v-progress-linear>
                            </v-list-item-subtitle>
                          </v-list-item-content>
                        </v-list-item>
                      </v-list>
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                </v-expansion-panels>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-card>
      </v-col>
    </v-row>

    <v-dialog v-model="showForm" max-width="800px">
      <v-card>
        <v-card-title>
          {{ editMode ? "Modifier" : "Nouvelle" }} page d'investigation
          <v-spacer></v-spacer>
          <v-btn icon @click="showForm = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <investigation-form @saved="onSaved" :investigation="selectedInvestigation" />
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import axios from "axios";
import InvestigationForm from "./InvestigationForm.vue";
import VueApexCharts from "vue-apexcharts";
import constants from "@/utils/constants";
import * as XLSX from 'xlsx'; // Si tu utilises un bundler (Vue, React)

export default {
  name: "InvestigationList",
  components: {
    apexchart: VueApexCharts,
    InvestigationForm,
  },
  data: () => ({
    showForm: false,
    editMode: false,
    selectedInvestigation: null,
    loading: false,
    investigations: [],
    label: [{}],
  }),
  async created() {
    await this.loadInvestigations();
  },
  methods: {
    getChartOptions(questionId) {
      return {
        chart: {
          type: "pie",
        },
        labels: this.getLabelsForChart(questionId),
        dataLabels: {
          enabled: true,
          formatter: function (val, opts) {
            return opts.w.config.series[opts.seriesIndex] + " votes";
          },
          style: {
            fontSize: "14px",
          },
        },
        responsive: [
          {
            breakpoint: 480,
            options: {
              chart: {
                width: 300,
              },
              legend: {
                position: "bottom",
              },
            },
          },
        ],
      };
    },
    getSeries(question) {
      return question.investigationRespRespList.map(
        (response) => response.numberVote
      );
    },
    getLabelsForChart(question) {
      return question.investigationRespRespList.map(
        (response) => response.response
      );
    },
    async loadInvestigations() {
      this.loading = true;
      try {
        const response = await axios.get(
          `${constants.QORANI}investigation/getall`
        );
        this.investigations = response.data;
      } catch (error) {
        console.error("Erreur lors du chargement des investigations:", error);
      }
      this.loading = false;
    },
    openNewInvestigation() {
      this.editMode = false;
      this.selectedInvestigation = null;
      this.showForm = true;
    },
    editInvestigation(investigation) {
      this.editMode = true;
      this.selectedInvestigation = { ...investigation };
      this.showForm = true;
    },
    async deleteInvestigation(investigation) {
      console.log(investigation.id);
      try {
        await axios.delete(
          `${constants.QORANI}investigation/delete/${investigation.id}`
        );
        await this.loadInvestigations();
      } catch (error) {
        console.error("Erreur parce que je ne suis pas connecté au serveur:", error);
      }
    },
    onSaved() {
      this.showForm = false;
      this.editMode = false;
      this.selectedInvestigation = null;
      this.loadInvestigations();
    },
    getColorByVotes(votes) {
      if (votes >= 4) return "success";
      if (votes >= 2) return "warning";
      return "info";
    },
    getPercentage(votes, responses) {
      const totalVotes = responses.reduce(
        (sum, response) => sum + response.numberVote,
        0
      );
      return totalVotes === 0 ? 0 : (votes / totalVotes) * 100;
    },
    getTotalVotes(responses) {
      return responses.reduce((sum, response) => sum + response.numberVote, 0);
    },
    getMostVotedColor(responses) {
      const maxVotes = Math.max(...responses.map((r) => r.numberVote));
      return this.getColorByVotes(maxVotes);
    },
    generateExcel(investigation) {
      const titleText = investigation.title ? `Résumé du sondage : ${investigation.title}` : "Résumé du sondage";
      const summarySheet = [
        [titleText],
        ["Nombre de réponses", "Nombre d'ignorés", "Total reçus"],
        [investigation.nbrResponse, investigation.nbrIgnore, investigation.nbrResponse + investigation.nbrIgnore],
        [],
      ];

      const detailTitle = ["Détail des réponses"];
      const detailHeader = ["Question", "Réponse", "Nombre de votes"];
      const detailRows = [];

      investigation.investigationQstRespList.forEach((q) => {
        q.investigationRespRespList.forEach((resp) => {
          detailRows.push([q.question, resp.response, resp.numberVote]);
        });
        detailRows.push([]); // ligne vide entre chaque question
      });

      const allData = [
        ...summarySheet,
        detailTitle,
        [],
        detailHeader,
        ...detailRows
      ];

      // Création de la feuille brute
      const worksheet = XLSX.utils.aoa_to_sheet(allData);

      // === Appliquer du GRAS ===
      const boldCells = [
        'A1', // "Résumé de l'investigation"
        'A2', 'B2', 'C2', // En-tête du résumé
        `A${summarySheet.length + 1}`, // "Détail des réponses"
        `A${summarySheet.length + 3}`, `B${summarySheet.length + 3}`, `C${summarySheet.length + 3}` // En-tête des questions
      ];

      boldCells.forEach((cell) => {
        if (worksheet[cell]) {
          worksheet[cell].s = {
            font: { bold: true }
          };
        }
      });

      // === Auto-ajuster la largeur des colonnes ===
      const columnWidths = detailHeader.map((_, colIndex) => {
        const lengths = allData.map(row => (row[colIndex] ? String(row[colIndex]).length : 0));
        const maxLength = Math.max(...lengths);
        return { wch: maxLength + 2 };
      });
      worksheet['!cols'] = columnWidths;

      // Création du classeur et téléchargement
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, 'Résultats');

      // IMPORTANT : writeFile doit être utilisé avec bookType xlsx pour conserver le style
      const fileName = investigation.title ? `${investigation.title}.xlsx` : 'sondage.xlsx';
      XLSX.writeFile(workbook, fileName, { bookType: 'xlsx', cellStyles: true });
    }

  },
};
</script>
